"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonI18n = require("@mmc/common-i18n");

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _vehicleCompare = _interopRequireDefault(require("../styles/vehicle-compare.css"));

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;

var VehicleCompareFooter = function VehicleCompareFooter(_ref) {
  var theme = _ref.theme,
      vehicleSelectedList = _ref.vehicleSelectedList,
      numberOfColumns = _ref.numberOfColumns,
      config = _ref.config;
  var numberOfMockColumn = numberOfColumns - vehicleSelectedList.length;
  var activeCardIndex = 0;

  function modelProperty(vehicle, modelCode, property) {
    var model = vehicle == null ? void 0 : vehicle.models.find(function (models) {
      return models.code === modelCode;
    });

    if (property === 'name') {
      return model.name;
    }

    if (property === 'price') {
      var _model$price;

      return model == null ? void 0 : (_model$price = model.price) == null ? void 0 : _model$price.value;
    }
  }

  var pathConfigureUrl = function pathConfigureUrl(vehicleSelected) {
    var _vehicleSelected$cta;

    var pathConfigure = (vehicleSelected == null ? void 0 : (_vehicleSelected$cta = vehicleSelected.cta) == null ? void 0 : _vehicleSelected$cta.url) + "&model=" + vehicleSelected.value + "&step=ColorSelector";
    return pathConfigure;
  };

  var handleClick = function handleClick(vehicleSelected) {
    var _vehicleSelected$cta2;

    var pathConfigure = (vehicleSelected == null ? void 0 : (_vehicleSelected$cta2 = vehicleSelected.cta) == null ? void 0 : _vehicleSelected$cta2.url) + "&model=" + vehicleSelected.value + "&step=ColorSelector";

    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'comparison_CTAs',
        comparison: {
          linkText: 'configure',
          linkUrl: pathConfigure
        }
      });
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    key: Math.random(),
    className: _vehicleCompare["default"].vehicleCompareFooterContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row + " " + _vehicleCompare["default"].noMargin + " " + _vehicleCompare["default"].forceWidth
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-sm-1'] + " " + _vehicleCompare["default"].noPadding
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-sm-10'] + " " + _vehicleCompare["default"].noPadding + " " + _vehicleCompare["default"].forceWidth
  }, /*#__PURE__*/_react["default"].createElement("div", {
    key: Math.random(),
    className: _vehicleCompare["default"].fieldsContainer
  }, vehicleSelectedList.slice(0, numberOfColumns).map(function (vehicle) {
    var _vehicle$price, _vehicle$price$displa, _vehicle$cta;

    return /*#__PURE__*/_react["default"].createElement("div", {
      key: Math.random(),
      className: _vehicleCompare["default"].fieldsSection
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _vehicleCompare["default"].textDropdownContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _vehicleCompare["default"].vehicleInfoContainer
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: _vehicleCompare["default"].selectedVehicleName
    }, vehicle.name), /*#__PURE__*/_react["default"].createElement("p", {
      className: _vehicleCompare["default"].selectedModelName
    }, modelProperty(vehicle, vehicle.value, 'name')), /*#__PURE__*/_react["default"].createElement("p", {
      className: _vehicleCompare["default"].pricingDetails
    }, vehicle == null ? void 0 : (_vehicle$price = vehicle.price) == null ? void 0 : (_vehicle$price$displa = _vehicle$price.displayValue) == null ? void 0 : _vehicle$price$displa.split('#')[0]), /*#__PURE__*/_react["default"].createElement("p", {
      className: "" + _vehicleCompare["default"].selectedModelPriceName
    }, /*#__PURE__*/_react["default"].createElement(_commonI18n.CommonI18N, {
      format: "price",
      returnZero: true,
      options: {
        value: modelProperty(vehicle, vehicle.value, 'price'),
        currency: handleNestedProp(config, 'config.currencyFormat'),
        locale: handleNestedProp(config, 'config.localeCode')
      }
    })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
      href: pathConfigureUrl(vehicle),
      className: theme.low + " " + _vehicleCompare["default"].configureLink,
      onClick: function onClick() {
        return handleClick(vehicle);
      },
      target: "_blank",
      rel: "noreferrer"
    }, vehicle == null ? void 0 : (_vehicle$cta = vehicle.cta) == null ? void 0 : _vehicle$cta.label, /*#__PURE__*/_react["default"].createElement("span", {
      className: "" + _vehicleCompare["default"].configureIcon
    }))))));
  }), function () {
    var mockData = [];

    var renderCards = function renderCards() {
      for (var i = 0; i < numberOfMockColumn; i++) {
        var isBesideActiveCard = i === activeCardIndex || i === activeCardIndex - 1;
        var className = _vehicleCompare["default"].fieldsSection + " " + (isBesideActiveCard ? '' : _vehicleCompare["default"].transparent);
        mockData.push( /*#__PURE__*/_react["default"].createElement("div", {
          key: i,
          className: className
        }));
      }
    };

    renderCards();
    return mockData;
  }())), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-sm-1'] + " " + _vehicleCompare["default"].noPadding
  }))));
};

var _default = VehicleCompareFooter;
exports["default"] = _default;